module.exports = __webpack_public_path__ + "static/media/Item_Row_Purple@3x.6f9fc035.png";